/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGOT_PSD = 'FORGOT_PSD';
export const FORGOT_PSD_SUCCESS = 'FORGOT_PSD_SUCCESS';
export const FORGOT_PSD_ERROR = 'FORGOT_PSD_ERROR';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
  'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/* SURVEY LIST APP */
export const SURVEY_LIST_GET_LIST = 'SURVEY_LIST_GET_LIST';
export const SURVEY_LIST_GET_LIST_SUCCESS = 'SURVEY_LIST_GET_LIST_SUCCESS';
export const SURVEY_LIST_GET_LIST_ERROR = 'SURVEY_LIST_GET_LIST_ERROR';
export const SURVEY_LIST_GET_LIST_WITH_FILTER =
  'SURVEY_LIST_GET_LIST_WITH_FILTER';
export const SURVEY_LIST_GET_LIST_WITH_ORDER =
  'SURVEY_LIST_GET_LIST_WITH_ORDER';
export const SURVEY_LIST_GET_LIST_SEARCH = 'SURVEY_LIST_GET_LIST_SEARCH';
export const SURVEY_LIST_GET_LIST_SEARCH_SUCCESS =
  'SURVEY_LIST_GET_LIST_SEARCH_SUCCESS';
export const SURVEY_LIST_GET_LIST_SEARCH_ERROR =
  'SURVEY_LIST_GET_LIST_SEARCH_ERROR';
export const SURVEY_LIST_ADD_ITEM = 'SURVEY_LIST_ADD_ITEM';
export const SURVEY_LIST_ADD_ITEM_SUCCESS = 'SURVEY_LIST_ADD_ITEM_SUCCESS';
export const SURVEY_LIST_ADD_ITEM_ERROR = 'SURVEY_LIST_ADD_ITEM_ERROR';
export const SURVEY_LIST_SELECTED_ITEMS_CHANGE =
  'SURVEY_LIST_SELECTED_ITEMS_CHANGE';
export const SURVEY_UPT_EULA = 'SURVEY_UPT_EULA';
export const SURVEY_UPT_EULA_SUCCESS = 'SURVEY_UPT_EULA_SUCCESS';

/* SURVEY DETAIL APP */
export const SURVEY_GET_DETAILS = 'SURVEY_GET_DETAILS';
export const SURVEY_GET_DETAILS_SUCCESS = 'SURVEY_GET_DETAILS_SUCCESS';
export const SURVEY_GET_DETAILS_ERROR = 'SURVEY_GET_DETAILS_ERROR';
export const SURVEY_DELETE_QUESTION = 'SURVEY_DELETE_QUESTION';
export const SURVEY_SAVE = 'SURVEY_SAVE';
export const SURVEY_SAVE_QUES = 'SURVEY_SAVE_QUES';
export const SURVEY_DELETE_PAGE = 'SURVEY_DELETE_PAGE';
export const MOVE_QUES_UP = 'MOVE_QUES_UP';
export const MOVE_QUES_DOWN = 'MOVE_QUES_DOWN';
export const ADD_QUES = 'ADD_QUES';
export const UPT_QUES = 'UPT_QUES';
export const UPT_FORM = 'UPT_FORM';
export const UPT_QUES_OBJ = 'UPT_QUES_OBJ';
export const SET_BRANCHING = 'SET_BRANCHING';
export const UPT_TO_SERVER = 'UPT_TO_SERVER';
export const SET_ACTIVE = 'SET_ACTIVE';
export const SET_FORCE = 'SET_FORCE';
export const SURVEY_LIST_DEL_SUCCESS = 'SURVEY_LIST_DEL_SUCCESS';
export const SURVEY_LIST_DEL_ERROR = 'SURVEY_LIST_DEL_ERROR';
export const SURVEY_LIST_DEL = 'SURVEY_LIST_DEL';
export const SET_LOAD = 'SET_LOAD';
export const SET_ROUND = 'SET_ROUND';


/* SURVEY VIEW APP */
export const SURVEY_VIEW_GET_FORM = 'SURVEY_VIEW_GET_FORM';
export const SURVEY_VIEW_GET_FORM_SUCCESS = 'SURVEY_VIEW_GET_FORM_SUCCESS';
export const SURVEY_VIEW_GET_FORM_ERROR = 'SURVEY_VIEW_GET_FORM_ERROR';
export const SURVEY_UPT_PAGE_VISIBLE = 'SURVEY_UPT_PAGE_VISIBLE';
export const GET_ANS = 'GET_ANS';
export const GET_ANS_SUCCESS = 'GET_ANS_SUCCESS';
export const GET_ANS_ERROR = 'GET_ANS_ERROR';
export const UPT_ANS = 'UPT_ANS';
export const CLR_QUES_1 = 'CLR_QUES_1';
export const CLR_QUES_2 = 'CLR_QUES_2';
export const SURVEY_VIEW_SET_VALIDATION = 'SURVEY_VIEW_SET_VALIDATION';
export const SURVEY_VIEW_UNSET_VALIDATION = 'SURVEY_VIEW_UNSET_VALIDATION';
export const SURVEY_VIEW_SET_PAGE_TOUCH_VALIDATION = 'SURVEY_VIEW_SET_PAGE_TOUCH_VALIDATION';
export const SURVEY_UPTSTRUC = 'SURVEY_UPTSTRUC';
export const SET_DUP_CID = 'SET_DUP_CID';
export const SURVEY_VIEW_LIVE_SCORE = 'SURVEY_VIEW_LIVE_SCORE';


// User Permission
export const FETCH_USER = 'FETCH_USER';
export const UPT_USER = 'UPT_USER';
export const SURVEY_PAGING_UPDATE = 'SURVEY_PAGING_UPDATE'
export const UPT_LAUNCH = 'UPT_LAUNCH'
export const UPT_LAUNCH_SERVER = 'UPT_LAUNCH_SERVER'
export const UPT_PWI = 'UPT_PWI'

// report
export const SURVEY_REPORT_GET_RES = 'SURVEY_REPORT_GET_RES'
export const SURVEY_REPORT_GET_BACKUP = 'SURVEY_REPORT_GET_BACKUP'
export const SURVEY_REPORT_LOAD = 'SURVEY_REPORT_LOAD'


export * from './menu/actions';
export * from './settings/actions';
export * from './auth/actions';
export * from './surveyList/actions';
export * from './surveyDetail/actions';
export * from './surveyView/actions';
export * from './SurveyReport/actions';
